import { type FC } from "react"

import { exhaustiveGuard } from "@forento/core/utilities/switch"

import Layout, { PageBreadcrumb } from "~/components/Layout"
import { usePlatform } from "~/contexts/UserContext"
import routes from "~/utilities/routes"

import AiCreditHistory from "./AiCreditHistory"
import AiCredits from "./AiCredits"
import AppSumo from "./AppSumo"
import ProductCanyon from "./ProductCanyon"
import Regular from "./Regular"
import VieDeDingue from "./VieDeDingue"

const BillingSettingsPage: FC = () => {
	const platform = usePlatform()!

	return (
		<Layout>
			<PageBreadcrumb title="Billing &amp; Plans" path={[{ title: "Settings", link: routes.settings.index() }]} />
			<AiCredits />
			{platform.plan.type === "free" || platform.plan.type === "regular" ? (
				<Regular platformPlan={platform.plan} />
			) : platform.plan.type === "appsumo" ? (
				<AppSumo platformPlan={platform.plan} />
			) : platform.plan.type === "productcanyon" ? (
				<ProductCanyon platformPlan={platform.plan} />
			) : platform.plan.type === "viededingue" ? (
				<VieDeDingue platformPlan={platform.plan} />
			) : (
				exhaustiveGuard(platform.plan)
			)}
			<AiCreditHistory />
		</Layout>
	)
}

export default BillingSettingsPage
